/* ============================================================
   MONARCA LIVING — Product Page JS
   assets/monarca-product.js
   ============================================================ */

(function () {
  'use strict';

  // ─── THUMBNAIL GALLERY ────────────────────────────────────
  var featuredImg = document.getElementById('mlv-featured-img');
  var thumbsTrack = document.getElementById('mlv-thumbs-track');
  var thumbPrev   = document.getElementById('mlv-thumb-prev');
  var thumbNext   = document.getElementById('mlv-thumb-next');

  if (thumbsTrack) {
    var thumbs = thumbsTrack.querySelectorAll('.mlv-product__thumb');
    var thumbOffset = 0;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Update active state
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        // Update main image
        if (featuredImg) {
          featuredImg.src = thumb.getAttribute('data-media-src');
          featuredImg.alt = thumb.getAttribute('data-media-alt') || '';
        }
      });
    });

    // Thumb navigation
    if (thumbPrev) {
      thumbPrev.addEventListener('click', function () {
        thumbOffset = Math.max(0, thumbOffset - 1);
        var thumbW = thumbs[0] ? thumbs[0].offsetWidth + 8 : 88;
        thumbsTrack.style.transform = 'translateX(-' + (thumbOffset * thumbW) + 'px)';
      });
    }

    if (thumbNext) {
      thumbNext.addEventListener('click', function () {
        thumbOffset = Math.min(thumbs.length - 1, thumbOffset + 1);
        var thumbW = thumbs[0] ? thumbs[0].offsetWidth + 8 : 88;
        thumbsTrack.style.transform = 'translateX(-' + (thumbOffset * thumbW) + 'px)';
      });
    }
  }

  // ─── QTY SELECTOR ────────────────────────────────────────
  var qtyInput = document.getElementById('mlv-qty-input');
  var qtyMinus = document.getElementById('mlv-qty-minus');
  var qtyPlus  = document.getElementById('mlv-qty-plus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
      }
    });

    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });

    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (!val || val < 1) qtyInput.value = 1;
    });
  }

  // ─── VARIANT SELECTION ───────────────────────────────────
  var form = document.getElementById('mlv-product-form');
  if (!form) return;

  var variantIdInput = document.getElementById('mlv-variant-id');
  var addBtn         = document.getElementById('mlv-add-btn');
  var buyNowBtn      = document.getElementById('mlv-buynow-btn');
  var priceEl        = document.getElementById('mlv-price');

  // Gather all option radios
  var optionInputs = form.querySelectorAll('.mlv-product__swatch-input, .mlv-product__pill-input');

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var optionIndex = parseInt(input.getAttribute('data-option-index'), 10);

      // Update displayed option value label
      var label = document.getElementById('mlv-option-val-' + (optionIndex + 1));
      if (label) label.textContent = input.value;

      // Update active swatch/pill UI
      var siblings = form.querySelectorAll('[data-option-index="' + optionIndex + '"]');
      siblings.forEach(function (sib) {
        sib.parentElement.classList.remove('is-selected');
      });
      input.parentElement.classList.add('is-selected');

      // Build selected options array
      var selectedOptions = [];
      for (var i = 0; i < 3; i++) {
        var checked = form.querySelector('[data-option-index="' + i + '"]:checked');
        if (checked) selectedOptions.push(checked.value);
      }

      // Find matching variant via productJSON global
      if (window.__monarcaProductJSON) {
        var variants = window.__monarcaProductJSON.variants;
        var match = variants.find(function (v) {
          return v.options.every(function (opt, idx) {
            return !selectedOptions[idx] || opt === selectedOptions[idx];
          });
        });

        if (match) {
          // Update hidden variant ID
          if (variantIdInput) variantIdInput.value = match.id;

          // Update price
          if (priceEl) {
            var price = (match.price / 100).toFixed(2);
            priceEl.textContent = '$' + price;
          }

          // Update add to cart button
          if (addBtn) {
            if (match.available) {
              addBtn.disabled = false;
              addBtn.textContent = 'ADD TO CART';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'SOLD OUT';
            }
          }

          // Update buy now URL
          if (buyNowBtn) {
            buyNowBtn.href = '/checkout?variant=' + match.id;
          }

          // Update featured image if variant has one
          if (match.featured_image && featuredImg) {
            featuredImg.src = match.featured_image.src;
          }
        }
      }
    });
  });

  // ─── ADD TO CART ──────────────────────────────────────────
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'ADDING...';
      }

      var formData = new FormData(form);
      var data = {
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'ADDED ✓';
          setTimeout(function () {
            addBtn.textContent = 'ADD TO CART';
          }, 2000);
        }

        // Trigger cart count refresh if Dawn's cart bubble exists
        var cartCountEl = document.querySelector('.cart-count-bubble');
        if (cartCountEl) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var countEls = document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]');
              countEls.forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        }
      })
      .catch(function () {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'ADD TO CART';
        }
      });
    });
  }

})();
